import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Padres hispanos en USA que trabajan jornada completa.', 'Familias que dependen del Daycare o niñeras durante el día.', 'Padres que se sienten al borde del colapso por la falta de sueño.', 'Personas que necesitan resultados prácticos en menos de una semana.'];
  const notForWho = ['Padres que buscan soluciones místicas o "mágicas" sin seguir una estructura.', 'Personas que no están dispuestas a comprometerse 7 días con un horario fijo.'];
  return <section className="py-24 px-4 bg-navy-900" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-15">
          {/* Para Quién Es */}
          <FadeIn direction="right" data-id="element-16">
            <div className="bg-navy-800 p-8 md:p-10 rounded-3xl border border-green-500/20" data-id="element-17">
              <h2 className="text-2xl md:text-3xl font-bold text-cream mb-8" data-id="element-18">
                Para Quién Es Esto
              </h2>
              <ul className="space-y-6" data-id="element-19">
                {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-20">
                    <div className="mt-1 bg-green-500/20 p-1 rounded-full shrink-0" data-id="element-21">
                      <CheckIcon className="w-4 h-4 text-green-400" data-id="element-22" />
                    </div>
                    <span className="text-muted leading-relaxed" data-id="element-23">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para Quién NO Es */}
          <FadeIn direction="left" delay={0.2} data-id="element-24">
            <div className="bg-navy-800 p-8 md:p-10 rounded-3xl border border-red-500/20 opacity-80" data-id="element-25">
              <h2 className="text-2xl md:text-3xl font-bold text-cream mb-8" data-id="element-26">
                Para Quién <span className="text-red-400" data-id="element-27">NO</span> Es Esto
              </h2>
              <ul className="space-y-6" data-id="element-28">
                {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-29">
                    <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-30">
                      <XIcon className="w-4 h-4 text-red-400" data-id="element-31" />
                    </div>
                    <span className="text-muted leading-relaxed" data-id="element-32">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}